import script from "./TableForDeal.vue?vue&type=script&setup=true&lang=js"
export * from "./TableForDeal.vue?vue&type=script&setup=true&lang=js"

import "./TableForDeal.vue?vue&type=style&index=0&id=11c3a455&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c3a455"]])

export default __exports__